import React from 'react'

export const EllipsisTextField = ({ record, source, ...props }) => {
  return (
    <span {...props} title={record && record[source]}>
      {record && record[source]}
    </span>
  )
}
